import { Guid } from '../guid';
import { Country } from '../country';
import { CvField } from './cv-field';

export class ResearchStay extends CvField implements JsonResearchStay<Date> {
  public static fromJson(
    {
      uid,
      projectTitle,
      university,
      department,
      lab,
      country,
      startDate,
      endDate,
      description,
      isCurrent,
      exclude
    }: JsonResearchStay<number>,
    cvId: string
  ): ResearchStay {
    return new ResearchStay(
      uid,
      cvId,
      projectTitle,
      university,
      department,
      lab,
      country ? (country as Country) : new Country(),
      startDate ? new Date(startDate) : null,
      endDate ? new Date(endDate) : null,
      description,
      isCurrent,
      exclude
    );
  }

  public static toJson(item: ResearchStay): JsonResearchStay<number> {
    return {
      uid: item.uid,
      cvId: item.cvId,
      projectTitle: item.projectTitle,
      university: item.university,
      department: item.department,
      lab: item.lab,
      country: item.country,
      startDate: item.startDate ? item.startDate.getTime() : null,
      endDate: item.endDate ? item.endDate.getTime() : null,
      description: item.description,
      isCurrent: item.isCurrent,
      exclude: item.exclude
    };
  }
  constructor(
    public readonly uid = Guid.newGuid(),
    public cvId = '',
    public projectTitle = '',
    public university = '',
    public department = '',
    public lab = '',
    public country: Country = new Country(),
    public startDate: Date = null,
    public endDate: Date = null,
    public description = '',
    public isCurrent = false,
    public exclude = false
  ) {
    super(exclude);
  }
}
export interface JsonResearchStay<T> {
  uid: string;
  cvId: string;
  projectTitle: string;
  university: string;
  department: string;
  lab: string;
  country: Country;
  startDate: T;
  endDate: T;
  description: string;
  isCurrent: boolean;
  exclude: boolean;
}
